<template>
  <div class="cb-item__sub-group cb-item__captions" ref="parent" v-if="canShowItemDescription">
    <cb-slide-n-fade>
      <div class="cb-item__captions-wrap" v-if="freeQuantity">
        <div class="cb-item__caption">
          {{ct('free_quantity.description', {units : freeQuantityToShow})}}
        </div>
      </div>
    </cb-slide-n-fade>
    <div class="cb-item__separator" v-if="showFirstSeparator"></div>
    <cb-slide-n-fade>
      <div class="cb-item__captions-wrap" v-if="canShowAmountSplit && (amountSplit.length == 1 || showMore)">
        <cb-slide-n-fade :is-list="true">
          <div class="cb-item__caption" v-for="(split, index) in amountSplit" v-bind:key="index">
            <span v-cb-html="split.desc"></span>
            <span class="cb-item__total" v-if="split.total">{{split.total}}</span>
          </div>
        </cb-slide-n-fade>
      </div>
    </cb-slide-n-fade>
    <div class="cb-item__separator" v-if="canShowAmountSplit && canShowDescription"></div>
    <cb-slide-n-fade>
      <div class="cb-item__captions-wrap" v-if="canShowDescription">
        <div class="cb-item__caption" v-cb-html="sanitizeTags(description, ['BR'])"></div>
      </div>
    </cb-slide-n-fade>
    <template v-if="showToggle">
      <span class="cb-item__action" @click="toggleShowMore()" v-if="!showMore">{{t('item.breakdown.show')}}</span>
      <span class="cb-item__action" @click="toggleShowMore()" v-else>{{t('item.breakdown.hide')}}</span>
    </template>
  </div>
</template>
<script type="text/javascript">
import TierHelper from '@/utils/lineitem-tier-helper'
export default {
    props: ['item', 'currencyCode', 'singleCart'],
    data() {
      return {
        showMore: false
      }
    },
    methods: {
      toggleShowMore() {
        this.showMore = !this.showMore;
      },
      sanitizeTags(content, allowedTags) {
      return {
        text: content,
        tags: allowedTags,
        attrs: []
      }
    }
    },
    computed:{
      canShowItemDescription() {
        return this.freeQuantity || this.canShowAmountSplit || this.description;
      },
      showToggle() {
        if(this.freeQuantity) {
          return this.canShowAmountSplit || this.description;
        } else if(this.canShowAmountSplit) {
          return this.amountSplit.length > 1 || this.description;
        }
        return false;
      },
      showFirstSeparator() {
        return this.freeQuantity && ((this.canShowAmountSplit || this.canShowDescription) && this.showMore);
      },
      freeQuantity() {
        return parseInt(this.item.free_quantity || 0);
      },
      quantity() {
        return parseInt(this.item.quantity || 0);
      },
      freeQuantityToShow() {
        return (this.quantity > this.freeQuantity) ? this.freeQuantity : this.quantity;
      },
      canShowAmountSplit() {
        return !this.singleCart && TierHelper.canShowAmountSplit(this.item) && this.quantity > 1;
      },
      amountSplit() {
        return TierHelper.getTierConstructor(this.item, this.currencyCode, this.$store.getters).constructAmountSplit();
      },
      canShowDescription() {
        return this.description && (!this.showToggle || this.showMore);
      },
      description() {
        return !this.singleCart && this.item.type == "plan" && this.item.details && this.item.details.description;
      }
    }
}
</script>


// WEBPACK FOOTER //
// ItemDescription.vue?fb4d9a9a